/* eslint-disable linebreak-style */
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagService {
	private flags: { [key: string]: any } = {};

	setFlags(flags: { [key: string]: any }): void {
		this.flags = { ...this.flags, ...flags };
	}

	getFlag(flagName: string): any {
		return this.flags[flagName];
	}

	getAllFlags(): { [key: string]: any } {
		return this.flags;
	}
}

